// src/components/GuestForm.js

import React, {
  useState
} from 'react';

const GuestForm = ({ onAdd, existingGuests = {} }) => {
  const [open, setOpen] = useState(false);
  const [name, setName] = useState('');
  const [xUrl, setXUrl] = useState('');
  const [profileText, setProfileText] = useState('');
  const [dupError, setDupError] = useState(false);

  const isDuplicate = (val) =>
    Object.values(existingGuests).some(
      g => (g.vrchat_name || '').trim().toLowerCase() === val.trim().toLowerCase()
    );

  const handleNameChange = (e) => {
    const v = e.target.value;
    setName(v);
    setDupError(v.trim() ? isDuplicate(v) : false);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name.trim() || dupError) return;

    onAdd({
      vrchat_name: name.trim(),
      x_url: xUrl.trim(),
      image_url: '',
      profile_text: profileText.trim(),
    });

    setName('');
    setXUrl('');
    setProfileText('');
    setDupError(false);
    setOpen(false);
  };

  const handleCancel = () => {
    setOpen(false);
    setName('');
    setXUrl('');
    setProfileText('');
    setDupError(false);
  };

  if (!open) {
    return (
      <button
        style={styles.addButton}
        onClick={() =>
          setOpen(true)
        }
      >
        ＋ ゲスト追加
      </button>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      style={styles.container}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        <div style={styles.row}>
          <input
            style={{ ...styles.input, borderColor: dupError ? '#ef4444' : '#d1d5db', flex: 1 }}
            value={name}
            onChange={handleNameChange}
            placeholder="VRChat名 (必須)"
            autoFocus
          />
          <input
            style={{ ...styles.input, flex: 1 }}
            value={xUrl}
            onChange={(e) => setXUrl(e.target.value)}
            placeholder="X URL (https://x.com/...)"
          />
        </div>
        {dupError && (
          <span style={{ fontSize: '12px', color: '#ef4444', fontWeight: '600' }}>
            ⚠️ 同じVRChat名がすでに登録されています
          </span>
        )}
      </div>

      <textarea
        style={styles.textarea}
        value={profileText}
        onChange={(e) =>
          setProfileText(
            e.target.value
          )
        }
        placeholder="プロフィールテキスト"
        rows={3}
      />

      <div style={styles.actions}>
        <button
          type="submit"
          disabled={!name.trim() || dupError}
          style={{
            ...styles.submitButton,
            opacity: !name.trim() || dupError ? 0.5 : 1,
            cursor: !name.trim() || dupError ? 'not-allowed' : 'pointer',
          }}
        >
          追加
        </button>

        <button
          type="button"
          style={styles.cancelButton}
          onClick={handleCancel}
        >
          キャンセル
        </button>
      </div>
    </form>
  );
};

const styles = {
  addButton: {
    width: '100%',
    border:
      '2px dashed #c7d2fe',
    background: '#eef2ff',
    color: '#4338ca',
    padding: '14px',
    borderRadius: '16px',
    cursor: 'pointer',
    fontWeight: '700',
    fontSize: '15px',
    transition: '0.2s',
    marginBottom: '20px'
  },

  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    background: '#f8fafc',
    border:
      '1px solid #e2e8f0',
    borderRadius: '16px',
    padding: '16px',
    marginBottom: '20px'
  },

  row: {
    display: 'flex',
    gap: '10px',
    flexWrap: 'wrap'
  },

  input: {
    flex: 1,
    minWidth: '180px',
    padding: '12px 14px',
    borderRadius: '12px',
    border:
      '1px solid #d1d5db',
    fontSize: '14px',
    outline: 'none'
  },

  textarea: {
    padding: '12px 14px',
    borderRadius: '12px',
    border:
      '1px solid #d1d5db',
    fontSize: '14px',
    outline: 'none',
    resize: 'vertical',
    fontFamily: 'inherit'
  },

  actions: {
    display: 'flex',
    gap: '10px'
  },

  submitButton: {
    flex: 1,
    background: '#6c63ff',
    color: '#fff',
    border: 'none',
    borderRadius: '12px',
    padding: '12px',
    cursor: 'pointer',
    fontWeight: '700',
    fontSize: '14px'
  },

  cancelButton: {
    flex: 1,
    background: '#fff',
    color: '#666',
    border: '1px solid #ddd',
    borderRadius: '12px',
    padding: '12px',
    cursor: 'pointer',
    fontWeight: '700',
    fontSize: '14px'
  }
};

export default GuestForm;